import Axios from 'axios';
import { decodeJwt } from 'jose';

interface RefresherArgs {
  readMeta: (s: string) => string | null;
  readDomainCookie: (s: string) => string | null;
  writeDomainCookie: (s: string, v: string, o?: any) => void;
  now: () => Date;
}

export default class Refresher {
  readMeta: (s: string) => string | null;

  readDomainCookie: (s: string) => string | null;

  writeDomainCookie: (s: string, v: string, o?: any) => void;

  now: () => Date;

  constructor(args: RefresherArgs) {
    this.readMeta = args.readMeta;
    this.readDomainCookie = args.readDomainCookie;
    this.writeDomainCookie = args.writeDomainCookie;
    this.now = args.now;
  }

  needsRefresh(token): boolean {
    const { exp } = decodeJwt(token);
    const currentTime = this.now().getTime();

    // 30s buffer so that we prevent the jwt expiring after the check but before the api call
    const buffer = 30000;

    if (exp) {
      return exp * 1000 - buffer <= currentTime;
    }

    return true;
  }

  async refresh(): Promise<string> {
    const refreshToken = this.readDomainCookie('refresh');
    const ssoUrl = this.readMeta('sso_url');

    if (!refreshToken || !ssoUrl) throw new Error('JWT can not be refreshed because refresh token is not present.');

    const response = await Axios.post(
      '/refresh',
      { refresh_token: refreshToken },
      {
        baseURL: ssoUrl,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.data) throw new Error('No data returned from refresh endpoint');

    this.writeDomainCookie('jwt', response.data.jwt);
    this.writeDomainCookie('refresh', response.data.refresh);

    return response.data.jwt;
  }
}
